export default __webpack_public_path__ + "static/media/ntorq-125-race.79de6c56.svg";